export const owners: Record<string, string[]> = {
  Askari: [
    "England",
    "Sweden",
    "Cape Verde",
    "Uruguay",
    "Uzbekistan",
    "Austria",
    "USA",
    "Morocco",
  ],
  Nour: [
    "New Zealand",
    "Australia",
    "Japan",
    "Senegal",
    "Brazil",
    "Iraq",
    "Panama",
    "Switzerland",
  ],
  Murray: [
    "Belgium",
    "South Africa",
    "Czechia",
    "Algeria",
    "Croatia",
    "Paraguay",
    "Iran",
    "Norway",
  ],
  Elliot: [
    "Argentina",
    "Ghana",
    "Ecuador",
    "Portugal",
    "Canada",
    "Colombia",
    "Saudi Arabia",
    "Spain",
  ],
  Rachel: [
    "Côte d'Ivoire",
    "France",
    "Jordan",
    "Haiti",
    "Netherlands",
    "Egypt",
    "Turkey",
    "Curaçao",
  ],
  Heja: [
    "Mexico",
    "Tunisia",
    "South Korea",
    "DR Congo",
    "Qatar",
    "Scotland",
    "Germany",
    "Bosnia and Herzegovina",
  ],
};

export const ownerNames = Object.keys(owners);

export const teamToOwner: Record<string, string> = Object.fromEntries(
  Object.entries(owners).flatMap(([owner, teams]) =>
    teams.map((team) => [team, owner])
  )
);

export const ownedTeams: string[] = Object.values(owners).flat();

const baseTeamNameMap: Record<string, string> = {
  "United States": "USA",
  "United States of America": "USA",

  "Czech Republic": "Czechia",

  "Ivory Coast": "Côte d'Ivoire",
  "Cote d'Ivoire": "Côte d'Ivoire",

  "Curacao": "Curaçao",

  "Korea Republic": "South Korea",
  "Korea, Republic of": "South Korea",
  "Republic of Korea": "South Korea",

  "Congo DR": "DR Congo",
  "Congo Democratic Republic": "DR Congo",
  "Democratic Republic of the Congo": "DR Congo",

  Bosnia: "Bosnia and Herzegovina",
  "Bosnia & Herzegovina": "Bosnia and Herzegovina",
  "Bosnia-Herzegovina": "Bosnia and Herzegovina",

  Columbia: "Colombia",

  "Türkiye": "Turkey",
  Turkiye: "Turkey",
  "Iran, Islamic Republic of": "Iran",
  "IR Iran": "Iran",
  "Cabo Verde": "Cape Verde",
  "Cape Verde Islands": "Cape Verde",
  "Republic of Ireland": "Ireland",
};

export function normaliseTeamName(
  rawName: string | null | undefined,
  manualMap: Record<string, string> = {}
): string | null {
  if (!rawName) return null;
  const trimmed = rawName.trim();
  if (!trimmed) return null;
  return manualMap[trimmed] ?? baseTeamNameMap[trimmed] ?? trimmed;
}

export function getOwnerFromApiName(
  rawName: string | null | undefined,
  manualMap: Record<string, string> = {}
): string | null {
  const normalised = normaliseTeamName(rawName, manualMap);
  if (!normalised) return null;
  return teamToOwner[normalised] ?? null;
}
